import React, { useEffect, useState, useContext } from 'react'
import { Col, Row, Input, Select, Button, List, message, Spin } from 'antd'
import debounce from 'lodash/debounce'
import PosSrc from '../../PosSrc'
import DBService from '../../../../utils/DBService'
import { Context, useStore } from '../../../../context'
import presentationSrc from '../../../products/components/presentationTabs/presentationSrc'
import Utils from '../../../../utils/Utils'

const { Option } = Select

function ProjectProductList(props) {
  const [state] = useContext(Context)

  const { hasPermissions } = useStore(state)
  const [productsList, setProductsList] = useState([])
  const [combosList, setCombosList] = useState([])
  const initDataSource = JSON.stringify([{ id: 1, product: null, discount_id: '', discount_amount: '', units: '', price: '', total: 0, type: '', presentation: null }])
  const [dataSource, setDataSource] = useState(JSON.parse(initDataSource))
  const [data, setData] = useState([])
  const [fetching, setFetching] = useState(false)
  const [loading, setLoading] = useState(false)

  const { auth } = state
  
  useEffect(() => {
    props.getProductsList(dataSource)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataSource])

  useEffect(() => {
    if (props.projectData.products && props.projectData.products.length > 0) {
      const presentationFuntion = async () => {
        const totalDataSource = []
        for (const item of props.projectData.products) {
          // item.total = item.total - ((item.price * item.units) * item.discount_amount) / 100

          const response = await presentationSrc.getPresentation(item.product)

          item.presentation = response?.discount_presentation ? response?.discount_presentation : null

          totalDataSource.push(item)
        }
        setDataSource(totalDataSource)
      }
      presentationFuntion()

    } else {
      setDataSource(JSON.parse(initDataSource))
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.projectData.products])

  useEffect(() => {
    const productsList = getProductListWithoutStock

    if (props.edit) setDataSource(productsList)    
    // eslint-disable-next-line
  }, [props.edit])

  useEffect(() => {
    if (props.isSellCancelled) {
      props.uncancellSell && props.uncancellSell()
      setData([])
      setDataSource(JSON.parse(initDataSource))
    } else {
      fetchProducts()
    }

    return () => {
      setData([])
      setDataSource(JSON.parse(initDataSource))
    }
    // eslint-disable-next-line
  }, [props.isSellCancelled])

  const getProductListWithoutStock = () => {
    return props.productsList.map(obj => {
      const itemsFiltered = props.itemsWithoutStock.filter(
        item => (item.presentations.includes(obj.product))
      )
      return itemsFiltered.length > 0 ? { ...obj, color: 'orange' } : { ...obj, color: '' }
    })
  }

  const fetchProducts = async () => {
    setLoading(true)
    PosSrc.getAllProducts(props.store.id, props.turn.id)
      .then(async products => {
        if (products.errors?.message[0] === 'Error de conexion') {
          let _productsList = await DBService.getAll('products')
          setProductsList(_productsList)
        } else {
          setProductsList(products.data)
          DBService.add(products.data, 'products')
        }
        fetchCombos()
      })
      .catch(e => {
        console.log(e)
        message.error('No se ha podido cargar los productos.')
      })
  }

  const fetchCombos = () => {
    PosSrc.getAllCombos(state.auth.company_id)
      .then(async combos => {
        if (combos.errors?.message[0] === 'Error de conexion') {
          let _combosList = await DBService.getAll('combos')
          setCombosList(_combosList)
        } else {
          setCombosList(combos.data)
          DBService.add(combos.data, 'combos')
        }
        setLoading(false)
      })
      .catch(e => {
        console.log(e)
        message.error('No se ha podido cargar los combos.')
      })
  }

  const onAdd = () => {
    setDataSource(prevState => {
      const sorted = prevState.sort((a, b) => a.id - b.id)
      const lastItem = sorted[sorted.length - 1]
      const newRow = Object.assign(JSON.parse(initDataSource)[0], { id: lastItem.id + 1 })
      return [...sorted, newRow]
    })
  }

  const onSetProduct = async (product, row) => {
    let typeInfo = product.split('-')
    let productInfo = productsList.find(p => p.id === Number(typeInfo[0]) && p.type === typeInfo[1])

    onSetData(productInfo?.id, row.id, 'product', true)
    onSetData(productInfo?.type, row.id, 'type')
    onSetData(productInfo?.price, row.id, 'price')
    onSetData(row.price * (row.units !== '' ? row.units : 0), row.id, 'total')

    const response = await presentationSrc.getPresentation(productInfo.id)
    onSetData(response?.discount_presentation ? response?.discount_presentation : null, row.id, 'presentation')
  }

  const onSetPresentation = (id, row) => {
    const presentationInfo = row.presentation.find(element => element.id === id);
    onSetData(presentationInfo?.id, row.id, 'discount_id')
    onSetData(presentationInfo?.pivot.discount_amount, row.id, 'discount_amount')
    const porcentaje = presentationInfo.pivot.discount_amount
    const priceUnits = row.price * (row.units !== '' ? row.units : 0)
    // const priceRes = ((porcentaje * priceUnits) / 100)
    const price = priceUnits - porcentaje * row.units
    onSetData(price, row.id, 'total')
  }

  const onSetPrice = (e, row) => {
    onSetData(e, row.id)
    if (row.discount_id) {
      const presentationInfo = row.presentation.find(element => element.id === row.discount_id);
      onSetData(presentationInfo?.id, row.id, 'discount_id')
      const porcentaje = presentationInfo.pivot.discount_amount
      const priceUnits = row.price * (row.units !== '' ? row.units : 0)
      // const priceRes = ((porcentaje * priceUnits) / 100)
      const price = priceUnits - porcentaje * row.units

      onSetData(price, row.id, 'total')
    } else {
      onSetData(row.price * (row.units !== '' ? row.units : 0), row.id, 'total')
    }
  }

  const onSetUnits = (e, row) => {
    onSetData(e, row.id)

    if (row.discount_id) {
      const presentationInfo = row.presentation.find(element => element.id === row.discount_id);
      onSetData(presentationInfo?.id, row.id, 'discount_id')

      const porcentaje = presentationInfo.pivot.discount_amount
      const priceUnits = row.price * (row.units !== '' ? row.units : 0)
      // const priceRes = ((porcentaje * priceUnits) / 100)
      const price = priceUnits - porcentaje * row.units     

      onSetData(price, row.id, 'total')
    } else {
      onSetData(row.price * (row.units !== '' ? row.units : 0), row.id, 'total')
    }
  }

  const onSetData = (e, rowId, name, product = false) => {
    const inputName = name ? name : e.target.name
    const value = name ? e : e.target.value
    let newRow
    if (product) {
      setData([])
      if (name === 'discount_id') {
        newRow = {
          [inputName]: value
        }
      } else {
        newRow = {
          [inputName]: value,
          units: 1,
        }
      }

    } else {
      newRow = { [inputName]: value }
    }

    const newDataSource = dataSource.map(row => {
      if (row.id === rowId) {
        return Object.assign(row, newRow)
      }
      return row
    })
    setDataSource(newDataSource)
  }

  const onDelete = (e, rowId) => {
    if (dataSource.length === 1) return

    setDataSource(prevState => {
      const value = prevState.flatMap(row => (row.id !== rowId ? row : []))
      return value
    })
  }

  const fetchPresentations = value => {
    if (value.length >= 3) {
      setData([])
      setFetching(true)
      const excludeChars = Utils.excludedCharsContent(value)
      PosSrc.searchPresentations(props.store.id, props.turn.id, value, excludeChars, 'desc')
        .then(res => {
          if (res.errors?.message[0] === 'Error de conexion') {
            const _value = value.toLowerCase()
            const presentations = productsList.filter(p => p.description.toLowerCase().includes(_value) || p.skus?.toLowerCase().includes(_value))
            const presentationsDescriptions = presentations.map(p => p.description)
            let combos = combosList.filter(c => c.presentations.filter(cp => presentationsDescriptions.includes(cp.description)).length > 0)
            combos = combos.map(c => {
              return {
                id: c.id,
                description: c.description,
                price: c.suggested_price,
                type: 'COMBO',
              }
            })
            const _data = [...presentations, ...combos]
            setData(_data)
          } else {
            const data = res?.data.map(p => ({
              id: p.id,
              description: p.description,
              price: p.price,
              type: p.type,
            }))
            setData(data)
          }
          setFetching(false)
        })
        .catch(e => {
          console.log(e)
          message.error('No se ha podido cargar las presentaciones.')
        })
    } else {
      if (value.length === 0) {
        setData([])
      }
    }
  }

  const handleChange = value => {
    setFetching(false)
  }

  function trunc(x, decimalDigits = 2, returnText = true, longFixed = true) {
    x = Number(x);
    decimalDigits = Number(decimalDigits);

    x = x * (10 ** decimalDigits);
    x = x - x % 1;
    x = x / (10 ** decimalDigits);

    if (returnText)
      if (longFixed)
        return x.toFixed(decimalDigits);
      else
        return x.toString();
    else
      return x;
  }

  return (
    <>
      <h4 className={'section-space-list-bottom'} >Lista de productos</h4>
      <List
        id={'inventory-list'}
        size="small"
        rowKey="id"
        dataSource={dataSource}
        renderItem={(row, i) => (
          <List.Item>
            <Row gutter={24} align="bottom" className={'section-space-field w-100'} key={row.id}>
              <Col sm={1}>
                <div className={'title-space-bottom text-bold'}>{i + 1}</div>
              </Col>
              <Col sm={6}>
                {i === 0 && <div className={'title-space-field pl-2'}>Productos</div>}
                <Select
                  disabled={loading}
                  loading={loading}
                  autoFocus
                  className={'single-select'}
                  showSearch
                  value={productsList?.find(p => p.id === row.product && p.type === row.type)?.description}
                  placeholder="Nombre o SKU del producto"
                  notFoundContent={fetching ? <Spin size="small" /> : null}
                  filterOption={false}
                  onSearch={debounce(fetchPresentations, 1000)}
                  onChange={e => {
                    handleChange(e)
                    onSetProduct(e, row)
                  }}
                  size={'large'}
                  style={{ width: '100%', color: row.color ? row.color : '' }}
                >
                  {data.map((d, i) => (
                    <Option key={i} value={`${d.id}-${d.type}`}>
                      <span>{d.description}</span>
                    </Option>
                  ))}
                </Select>
              </Col>
              <Col sm={3}>
                {i === 0 && <div className={'title-space-field text-center'}>Precio unitario</div>}
                <Input
                  disabled={!row.product ? true : !hasPermissions([51])}
                  value={row.price}
                  onChange={e => onSetPrice(e, row)}
                  placeholder={'Precio'}
                  name={'price'}
                  size={'large'}
                  min="0"
                />
              </Col>
              <Col sm={3}>
                {i === 0 && <div className={'title-space-field text-center'}>No. Unidades</div>}
                <Input
                  disabled={!row.product && true}
                  value={row.units}
                  onChange={e => onSetUnits(e, row)}
                  placeholder={'No. Unidades'}
                  name={'units'}
                  size={'large'}
                  min="0"
                />
              </Col>
              {auth?.company?.allow_discount_levels === 1 && (
                <Col sm={5}>
                  {i === 0 && <div className={'title-space-field text-center'}>Nivel de descuento</div>}
                  <Select
                    disabled={row.presentation?.length === 0 || row.presentation === null || !row.product}
                    autoFocus
                    className={'single-select'}                    
                    placeholder="Nivel de descuento"
                    filterOption={false}
                    defaultValue={row.discount_level ? `${row.discount_level} - ${row.discount_amount}` : ''}
                    onChange={e => {
                      onSetPresentation(e, row)
                    }}
                    size={'large'}
                    style={{ width: '100%', color: row.color ? row.color : '' }}
                  >
                    {row.presentation && row.presentation.map((d, i) => (
                      <Option key={i} value={d.id}>
                        <span>{`${d.discount_level} - ${d.pivot.discount_amount}`}</span>
                      </Option>
                    ))}
                  </Select>
                </Col>
              )}

              <Col sm={3}>
                {i === 0 && <div className={'title-space-field text-center'}>Total</div>}
                <Input
                  style={{ textAlign: 'center' }}
                  disabled={true}
                  value={trunc(row.total)}
                  placeholder={'Q 0.00'}
                  name={'total'}
                  size={'large'}
                  min="0"
                  className="total-product"
                />
              </Col>
              <Col sm={3} className={'center-flex-div'}>
                <Button type={'link'} className="title-space-bottom cancel-button px-0 m-0" onClick={e => onDelete(e, row.id)}>
                  Eliminar
                </Button>
              </Col>
            </Row>
          </List.Item>
        )}
        footer={
          <Row gutter={16} className={'section-space-field'}>
            <Col sm={1}></Col>
            <Col sm={9}>
              <div className="title-tendero dashed-border-button" onClick={onAdd}>
                <svg className={'svg'} viewBox="0 0 300 100" preserveAspectRatio="none">
                  <path className={'path'} d="M0,0 300,0 300,100 0,100z" />
                </svg>
                <span className={'text'}>Agregar proyecto</span>
              </div>
            </Col>
            <Col sm={14}></Col>
          </Row>
        }
      />
    </>
  )
}

export default ProjectProductList
